import { createElement } from 'react';
import Edit from './Edit';
import View from './View';

export default props => createElement(props.editing ? Edit : View, props);
